/**
 * howItWorksModule - A class for handling functionality
 */
class howItWorksModule {
	/**
	 * Setup method
	 * Static method to set up the class on the page
	 *
	 * @return {void}
	 */
	static setup() {
		const elements = document.querySelectorAll('.qte-how-it-works-section');

		for (const element of elements) {
			const instance = new howItWorksModule(element);
			instance.init();
		}
	}

	/**
	 * Constructor method
	 *
	 * @param {HTMLElement} element
	 * @return {void}
	 */
	constructor(element) {
		this.element = element;
	}

	/**
	 * Initialize method
	 * Method to initialize a class instance
	 */
	init() {
		this.addEventListeners();
	}

	/**
	 * Add event listeners
	 *
	 * @return {void}
	 */
	addEventListeners() {
		this.element.addEventListener('click', this.showActiveStep.bind(this));
	}

	/**
	 * Click to activate a step in the module
	 *
	 * @param {Event} e
	 * @return {void}
	 */
	showActiveStep(e) {
		// Check if the clicked element is a text wrapper or within one
		const clickedTextWrapper = e.target.closest('.how-it-works-text-wrapper');

		if (!clickedTextWrapper) {
			return;
		}

		// Remove 'active' class from all text wrappers
		this.element.querySelectorAll('.how-it-works-text-wrapper').forEach((element) => {
			if (element.classList.contains('active')) {
				element.classList.remove('active');
			}
		});

		// Remove 'active' class from all step images
		this.element.querySelectorAll('.how-it-works-image-wrapper').forEach((image) => {
			if (image.classList.contains('active')) {
				image.classList.remove('active');
			}
		});

		if (clickedTextWrapper && !clickedTextWrapper.classList.contains('active')) {
			// Add 'active' class to the clicked text wrapper
			clickedTextWrapper.classList.add('active');

			// Find the index of the clicked text wrapper
			const textWrappers = Array.from(this.element.querySelectorAll('.how-it-works-text-wrapper'));
			const clickedIndex = textWrappers.indexOf(clickedTextWrapper);

			// Add 'active' class to the corresponding step image
			const stepImages = this.element.querySelectorAll('.how-it-works-image-wrapper');

			if (stepImages[clickedIndex]) {
				stepImages[clickedIndex].classList.add('active');
			}
		}
	}
}

// The document is checked if it is ready. If it is, the setup() method is called.
if (document.readyState === 'interactive' || document.readyState === 'complete') {
	howItWorksModule.setup();
} else {
	document.addEventListener('DOMContentLoaded', howItWorksModule.setup);
}
